

<!-- Our Process Section -->
<div class="container-fluid py-5" style="background: linear-gradient(135deg, #1e2a47, #2d9cdb);">
  <div class="row justify-content-center">
    <div class="col-12 text-center">
      <!-- Title Section -->
      <h1 class="fw-bolder" style="color: white; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px; border-bottom: 3px solid white; display: inline-block; padding-bottom: 10px;">
        Our Process
      </h1>
      
      
      <p style="color: #B0C4DE; 
        max-width: 700px; 
        margin: 20px auto; 
        font-family: 'Poppins', sans-serif; 
        font-size: 16px; 
        line-height: 1.6; 
        font-weight: 400;">
        
    Our purpose is to fulfill your financial needs, not to sell any financial  products. Serving you ethically as a financial guide, so you can achieve financial freedom and live a happy, wealthy, and prosperous life.
  
      </p>
    </div>
  </div>

  <!-- Process Steps Section -->
  <div class="row justify-content-center mt-5">
    <div class="col-md-10">
      <div class="row text-center">
        <!-- Step 1 -->
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="process-step">
            <div class="icon-box mb-3" style="
              width: 100px;
              height: 100px;
              background-color: white;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);">
              <i class="fas fa-users" style="font-size: 36px; color: #273C66;"></i>
            </div>
            <h5 style="color: #273C66; font-size: 1.3rem; font-family: 'Poppins', sans-serif;">Understanding Your Needs</h5>
            <p style="color: #273C66 ;font-size: 1.1rem; font-family:sans-serif;">
              We take time to understand your financial goals and develop a personalized plan.
            </p>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="process-step">
            <div class="icon-box mb-3" style="
              width: 100px;
              height: 100px;
              background-color: white;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);">
              <i class="fas fa-handshake" style="font-size: 36px; color: #273C66;"></i>
            </div>
            <h5 style="color: #273C66; font-size: 1.3rem; font-family: 'Poppins', sans-serif;">Choosing the Right Plan</h5>
            <p style="color: #273C66; font-size: 1.1rem; font-family: sans-serif;">
              We help you select the best financial products that suit your needs.
            </p>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="process-step">
            <div class="icon-box mb-3" style="
              width: 100px;
              height: 100px;
              background-color: white;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);">
              <i class="fas fa-money-check-alt" style="font-size: 36px; color: #273C66;"></i>
            </div>
            <h5 style="color: #273C66; font-size: 1.3rem; font-family: 'Poppins', sans-serif;">Transaction Assistance</h5>
            <p style="color: #273C66; font-size:1.1rem; font-family: sans-serif;">
              We assist you throughout the transaction process, ensuring a smooth experience.
            </p>
          </div>
        </div>
        

        <!-- Step 4 -->
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="process-step">
            <div class="icon-box mb-3" style="
              width: 100px;
              height: 100px;
              background-color: white;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);">
              <i class="fas fa-chart-line" style="font-size: 36px; color: #273C66;"></i>
            </div>
            <h5 style="color: #273C66; font-size: 1.3rem; font-family: 'Poppins', sans-serif;">Progress Tracking</h5>
            <p style="color: #273C66; font-size: 1.1rem; font-family: sans-serif;">
              We monitor your progress and adjust plans as needed to keep you on track.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Include Font Awesome for Icons -->
<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">



 




<div class="row justify-content-center" style="margin-top: 50px;"> 
  <div class="col-12 h1 text-center">
    <div class="text-center mb-2">
      <h1 class="fw-bolder" style="color: #273C66; 
          font-size: 1.9rem; 
          font-family: 'Poppins', sans-serif; 
          letter-spacing: 2px; 
          text-decoration: underline; 
          text-decoration-color: red; 
          text-underline-offset: 5px;">
        Testimonials
      </h1>
    </div>
  </div>

  <div class="col-md-5 mt-5">
    <div class="testimonial-card">
      <div class="testimonial-content">
        <p>
          The experience with SNP Money has been lovely. Investing is now extremely simple and non-scary. The whole process
          of buying the policy is online. It was quite easy as I searched on the website and explored various plans.
        </p>
      </div>
    </div>
  </div>

  <div class="col-md-5 mt-5">
    <div class="testimonial-card">
      <div class="testimonial-content card-text font-family-sans-serif,poppins, font-size-2rem,font-weight-900 ,color:#273C66;">
        <p>
          SNP Money is a great platform for investment. Interactive and clean User Interface. Features like creating your own
          portfolio are great. I started investing in MF due to SNP Money only. Very responsive support team, always available 
          for queries.
        </p>
      </div>
    </div>
  </div>
</div>